const breakpointNames = ["mobile", "tablet", "desktop", "wide"];
const breakpoints = {
  mobile: 0,
  tablet: 767,
  desktop: 991,
  wide: 1280
};
export {
  breakpointNames,
  breakpoints
};
